import { render, staticRenderFns } from "./LessonDetailContent.vue?vue&type=template&id=0864ea18&scoped=true"
import script from "./LessonDetailContent.vue?vue&type=script&lang=js"
export * from "./LessonDetailContent.vue?vue&type=script&lang=js"
import style0 from "./LessonDetailContent.vue?vue&type=style&index=0&id=0864ea18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0864ea18",
  null
  
)

export default component.exports